/**
 * @module contexts/AppStateProvider
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React, { createContext, useContext, useReducer } from "react";


export const initialState = {
  fdsnws: (process.env.NODE_ENV==='development')?
    'https://fdsn.seismo.nrcan.gc.ca/fdsnws/station/1/query':
    '/fdsnws/station/1/query',
  colorMarkerTable: [
    '#4641D9',
    '#000000',
    '#D90F31',
    '#E038DE',
    '#30FCDD',
    '#FA9600',
    '#FCE830',
    '#AE30FC',
  ],
  datetimeFormat: 'YYYY-MM-DD',
  selected: null,
  // basemap assumes only 1 layer
  // the URL is defined in the language property to support french and englishj
  basemap: {
    proj4j: {
      name: 'EPSG:3978',
      value: '+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      // origin/resolutions is based by the values advertised for each layer of the used basemap
      origin: [-3.46558E7, 3.931E7],
      resolutions: [
        38364.660062653464,
        22489.62831258996,
        13229.193125052918,
        7937.5158750317505,
        4630.2175937685215,
        2645.8386250105837,
        1587.5031750063501,
        926.0435187537042,
        529.1677250021168,
        317.50063500127004,
        185.20870375074085,
        111.12522225044451,
        66.1459656252646,
        38.36466006265346,
        22.48962831258996,
        13.229193125052918,
        7.9375158750317505,
        4.6302175937685215,
      ],
    },
  },
}


export const SET_FDSNWS = 'SET_FDSNWS';
export const SET_SELECTED_STATION = 'SET_SELECTED_STATION';


const reducer = (state, action) => {
  switch (action.type) {
    case SET_FDSNWS:
      return {
        ...state,
        fdsnws: action.payload,
      }
    case SET_SELECTED_STATION:
      return {
        ...state,
        selected: action.payload,
      }
    default:
      return state;
  }
}


export const AppContext = createContext();


export const AppStateProvider = ({ initialState, children }) => (
  <AppContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </AppContext.Provider>
);


export const useAppState = () => useContext(AppContext);
